// src/belediye/hooks/useModuleEnabled.js
// Modül aç/kapa kapısı (frontend yüzü) — /me.enabled_modules'tan okur.
//
// Kural: yalnız AÇIKÇA false ise kapalı say (undefined/eksik → açık) —
// eski yanıtlar/legacy akış kırılmasın. Backend zaten gerçek kapı
// (ModuleGateMiddleware 404); bu hook yalnız İZ bırakmamak için UI gizler.
//
// Kullanım: const gorevModulu = useModuleEnabled("internal_tasks");

import { useSelector } from "react-redux";

import { selectAuthz } from "../redux/slices/authzSlice";

export function isModuleEnabled(enabledModules, key) {
  if (!enabledModules || typeof enabledModules !== "object") return true;
  return enabledModules[key] !== false;
}

export default function useModuleEnabled(key) {
  const authz = useSelector(selectAuthz);
  return isModuleEnabled(authz?.enabledModules, key);
}
